import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withKeys as _withKeys, vShow as _vShow } from "vue"

const _hoisted_1 = { id: "app" }
const _hoisted_2 = { id: "ui-elements" }
const _hoisted_3 = {
  class: "element-box",
  id: "display-panel-box"
}
const _hoisted_4 = { id: "overlays" }
const _hoisted_5 = {
  key: 0,
  id: "imagery-container"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "display-section-header" }, [
  /*#__PURE__*/_createElementVNode("label", null, "Imagery")
], -1)
const _hoisted_7 = {
  key: 1,
  id: "spreadsheets-container"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "display-section-header" }, [
  /*#__PURE__*/_createElementVNode("label", null, "Data Tables")
], -1)
const _hoisted_9 = {
  key: 2,
  id: "sources-container"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "display-section-header" }, [
  /*#__PURE__*/_createElementVNode("label", null, "Sources")
], -1)
const _hoisted_11 = {
  key: 0,
  class: "element-box",
  id: "tools-box"
}
const _hoisted_12 = { class: "tool-container" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "Foreground opacity:", -1)
const _hoisted_14 = {
  key: 1,
  id: "bg-select-container",
  class: "item-select-container"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", {
  id: "bg-select-title",
  class: "item-select-title"
}, "Background imagery:", -1)
const _hoisted_16 = { class: "item-option" }
const _hoisted_17 = { class: "ellipsize" }
const _hoisted_18 = { class: "ellipsize" }
const _hoisted_19 = { class: "ellipsize" }
const _hoisted_20 = {
  key: 2,
  class: "item-select-container"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "item-select-title" }, "Add imagery layer:", -1)
const _hoisted_22 = { class: "item-option" }
const _hoisted_23 = { class: "ellipsize" }
const _hoisted_24 = { class: "ellipsize" }
const _hoisted_25 = { class: "ellipsize" }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = {
  key: 3,
  id: "catalog-select-container-tool",
  class: "item-select-container"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "item-select-title" }, "Add catalog:", -1)
const _hoisted_29 = { class: "item-option" }
const _hoisted_30 = { class: "ellipsize" }
const _hoisted_31 = { class: "ellipsize" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_33 = {
  key: 4,
  class: "load-collection-container"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "load-collection-label" }, [
  /*#__PURE__*/_createTextVNode(" Load "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://docs.worldwidetelescope.org/data-guide/1/data-file-formats/collections/",
    target: "_blank"
  }, "WTML"),
  /*#__PURE__*/_createTextVNode(" data collection: ")
], -1)
const _hoisted_35 = { class: "load-collection-row" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", null, "URL:", -1)
const _hoisted_37 = {
  key: 5,
  class: "save-state-container"
}
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", { class: "save-state-title" }, "The current view can be restored using:", -1)
const _hoisted_39 = { class: "save-state-content" }
const _hoisted_40 = { class: "save-state-url" }
const _hoisted_41 = {
  class: "element-box",
  id: "controls-box"
}
const _hoisted_42 = {
  class: "tooltip-content tool-menu",
  tabindex: "-1"
}
const _hoisted_43 = ["onClick"]
const _hoisted_44 = ["onClick"]
const _hoisted_45 = ["onClick"]
const _hoisted_46 = ["onClick"]
const _hoisted_47 = ["onClick"]
const _hoisted_48 = /*#__PURE__*/_createElementVNode("a", { href: "https://discussions.apple.com/thread/8655829" }, "enable WebGL 2.0", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WorldWideTelescope = _resolveComponent("WorldWideTelescope")!
  const _component_imageset_item = _resolveComponent("imageset-item")!
  const _component_spreadsheet_item = _resolveComponent("spreadsheet-item")!
  const _component_source_item = _resolveComponent("source-item")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Popper = _resolveComponent("Popper")!
  const _component_notifications = _resolveComponent("notifications")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_WorldWideTelescope, {
      "wwt-namespace": _ctx.wwtComponentNamespace,
      class: _normalizeClass(['wwt', { pointer: _ctx.lastClosePt !== null }]),
      onPointermove: _ctx.wwtOnPointerMove,
      onPointerup: _ctx.wwtOnPointerUp,
      onPointerdown: _ctx.wwtOnPointerDown
    }, null, 8, ["wwt-namespace", "class", "onPointermove", "onPointerup", "onPointerdown"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (!_ctx.hideAllChrome)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              id: "display-panel",
              onKeydown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
            }, [
              _createVNode(_Transition, { name: "catalog-transition" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.coordText), 1)
                  ])
                ]),
                _: 1
              }),
              (_ctx.haveImagery)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _hoisted_6,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeImagesetLayerStates, (imageset) => {
                      return (_openBlock(), _createBlock(_component_imageset_item, {
                        key: imageset.guidText,
                        imageset: imageset
                      }, null, 8, ["imageset"]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.haveTableLayers)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _hoisted_8,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.spreadsheetLayers, (layer) => {
                      return (_openBlock(), _createBlock(_component_spreadsheet_item, {
                        key: layer.name,
                        layer: layer,
                        defaultColor: _ctx.defaultColor
                      }, null, 8, ["layer", "defaultColor"]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.haveSources)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _hoisted_10,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sources, (source) => {
                      return (_openBlock(), _createBlock(_component_source_item, {
                        key: source.name,
                        source: source
                      }, null, 8, ["source"]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ], 32))
          : _createCommentVNode("", true)
      ]),
      (!_ctx.hideAllChrome)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            (!_ctx.hideAllChrome)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  id: "tools",
                  onKeydown: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
                }, [
                  _createElementVNode("div", _hoisted_12, [
                    (_ctx.currentTool == 'crossfade')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _hoisted_13,
                          _withDirectives(_createElementVNode("input", {
                            class: "opacity-range",
                            type: "range",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.foregroundOpacity) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.foregroundOpacity]
                          ])
                        ], 64))
                      : (_ctx.currentTool == 'choose-background')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _hoisted_15,
                            _createVNode(_component_v_select, {
                              modelValue: _ctx.curBackgroundImagesetName,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.curBackgroundImagesetName) = $event)),
                              id: "bg-select",
                              class: "item-selector",
                              searchable: true,
                              clearable: false,
                              options: _ctx.curAvailableImagesets,
                              filter: _ctx.filterImagesets,
                              "close-on-select": true,
                              reduce: (bg) => bg.name,
                              getOptionKey: JSON.stringify,
                              label: "name",
                              placeholder: "Background"
                            }, {
                              option: _withCtx((option) => [
                                _createElementVNode("div", _hoisted_16, [
                                  _createElementVNode("h4", _hoisted_17, _toDisplayString(option.name), 1),
                                  _createElementVNode("p", _hoisted_18, [
                                    _createElementVNode("em", null, _toDisplayString(option.description), 1)
                                  ])
                                ])
                              ]),
                              "selected-option": _withCtx((option) => [
                                _createElementVNode("div", _hoisted_19, _toDisplayString(option.name), 1)
                              ]),
                              _: 1
                            }, 8, ["modelValue", "options", "filter", "reduce", "getOptionKey"])
                          ]))
                        : (_ctx.currentTool == 'add-imagery-layer')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                              _hoisted_21,
                              _createVNode(_component_v_select, {
                                class: "item-selector",
                                searchable: true,
                                clearable: false,
                                options: _ctx.curAvailableImageryData,
                                filter: _ctx.filterImagesets,
                                getOptionKey: JSON.stringify,
                                "onUpdate:modelValue": _ctx.addImagery,
                                label: "name",
                                placeholder: ""
                              }, {
                                option: _withCtx((option) => [
                                  _createElementVNode("div", _hoisted_22, [
                                    _createElementVNode("h4", _hoisted_23, _toDisplayString(option.name), 1),
                                    _createElementVNode("p", _hoisted_24, [
                                      _createElementVNode("em", null, _toDisplayString(option.description), 1)
                                    ])
                                  ])
                                ]),
                                "selected-option": _withCtx((option) => [
                                  _createElementVNode("div", _hoisted_25, _toDisplayString(option.name), 1)
                                ]),
                                "no-options": _withCtx(({ search, searching }) => [
                                  searching
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode(" No datasets matching "),
                                        _createElementVNode("em", null, _toDisplayString(search), 1),
                                        _createTextVNode(". ")
                                      ], 64))
                                    : (_openBlock(), _createElementBlock("em", _hoisted_26, "No datasets available. Load a WTML collection?"))
                                ]),
                                _: 1
                              }, 8, ["options", "filter", "getOptionKey", "onUpdate:modelValue"])
                            ]))
                          : (_ctx.showCatalogChooser)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                _hoisted_28,
                                _createVNode(_component_v_select, {
                                  id: "catalog-select-tool",
                                  class: "item-selector",
                                  searchable: true,
                                  clearable: false,
                                  options: _ctx.curAvailableCatalogs,
                                  filter: _ctx.filterCatalogs,
                                  "onUpdate:modelValue": _ctx.addHips,
                                  label: "name",
                                  placeholder: ""
                                }, {
                                  option: _withCtx((option) => [
                                    _createElementVNode("div", _hoisted_29, [
                                      _createElementVNode("h4", _hoisted_30, _toDisplayString(option.name), 1),
                                      _createElementVNode("p", _hoisted_31, [
                                        _createElementVNode("em", null, _toDisplayString(option.description), 1)
                                      ])
                                    ])
                                  ]),
                                  "selected-option-container": _withCtx(({}) => [
                                    _hoisted_32
                                  ]),
                                  _: 1
                                }, 8, ["options", "filter", "onUpdate:modelValue"])
                              ]))
                            : (_ctx.currentTool == 'load-collection')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                  _hoisted_34,
                                  _createElementVNode("div", _hoisted_35, [
                                    _hoisted_36,
                                    _withDirectives(_createElementVNode("input", {
                                      type: "url",
                                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.wtmlCollectionUrl) = $event)),
                                      onKeyup: _cache[4] || (_cache[4] = _withKeys(
//@ts-ignore
(...args) => (_ctx.submitWtmlCollectionUrl && _ctx.submitWtmlCollectionUrl(...args)), ["enter"]))
                                    }, null, 544), [
                                      [_vModelText, _ctx.wtmlCollectionUrl]
                                    ]),
                                    _createVNode(_component_font_awesome_icon, {
                                      icon: "arrow-circle-right",
                                      size: "lg",
                                      class: "load-collection-icon",
                                      onKeyup: _withKeys(_ctx.submitWtmlCollectionUrl, ["enter"]),
                                      onClick: _ctx.submitWtmlCollectionUrl,
                                      tabindex: "0"
                                    }, null, 8, ["onKeyup", "onClick"])
                                  ])
                                ]))
                              : (_ctx.currentTool == 'save-state')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                    _hoisted_38,
                                    _createElementVNode("div", _hoisted_39, [
                                      _createElementVNode("span", _hoisted_40, _toDisplayString(this.stateAsUrl()), 1),
                                      _createVNode(_component_font_awesome_icon, {
                                        icon: "copy",
                                        size: "lg",
                                        class: "pointer",
                                        onClick: _ctx.copyStateURL,
                                        onKeyup: _withKeys(_ctx.copyStateURL, ["enter"]),
                                        tabindex: "0"
                                      }, null, 8, ["onClick", "onKeyup"])
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                  ])
                ], 32))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_41, [
        (!_ctx.hideAllChrome)
          ? (_openBlock(), _createElementBlock("ul", {
              key: 0,
              id: "controls",
              onKeydown: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["stop"]))
            }, [
              _withDirectives(_createElementVNode("li", null, [
                _createVNode(_component_Popper, {
                  placement: "left",
                  arrow: true,
                  interactive: true
                }, {
                  content: _withCtx((props) => [
                    _createElementVNode("ul", _hoisted_42, [
                      _withDirectives(_createElementVNode("li", null, [
                        _createElementVNode("a", {
                          href: "#",
                          onClick: ($event: any) => {
                        _ctx.selectTool('choose-background');
                        props.close();
                      },
                          tabindex: "0"
                        }, [
                          _createVNode(_component_font_awesome_icon, { icon: "mountain" }),
                          _createTextVNode(" Choose background")
                        ], 8, _hoisted_43)
                      ], 512), [
                        [_vShow, _ctx.showBackgroundChooser]
                      ]),
                      _withDirectives(_createElementVNode("li", null, [
                        _createElementVNode("a", {
                          href: "#",
                          onClick: ($event: any) => {
                        _ctx.selectTool('add-imagery-layer');
                        props.close();
                      },
                          tabindex: "0"
                        }, [
                          _createVNode(_component_font_awesome_icon, { icon: "image" }),
                          _createTextVNode(" Add imagery as layer")
                        ], 8, _hoisted_44)
                      ], 512), [
                        [_vShow, _ctx.showAddImageryTool]
                      ]),
                      _withDirectives(_createElementVNode("li", null, [
                        _createElementVNode("a", {
                          href: "#",
                          onClick: ($event: any) => {
                        _ctx.selectTool('choose-catalog');
                        props.close();
                      },
                          tabindex: "0"
                        }, [
                          _createVNode(_component_font_awesome_icon, { icon: "map-marked-alt" }),
                          _createTextVNode(" Add HiPS catalogs")
                        ], 8, _hoisted_45)
                      ], 512), [
                        [_vShow, _ctx.showCatalogTool]
                      ]),
                      _withDirectives(_createElementVNode("li", null, [
                        _createElementVNode("a", {
                          href: "#",
                          onClick: ($event: any) => {
                        _ctx.selectTool('load-collection');
                        props.close();
                      },
                          tabindex: "0"
                        }, [
                          _createVNode(_component_font_awesome_icon, { icon: "photo-video" }),
                          _createTextVNode(" Load WTML collection")
                        ], 8, _hoisted_46)
                      ], 512), [
                        [_vShow, _ctx.showCollectionLoader]
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          href: "#",
                          onClick: ($event: any) => {
                        _ctx.selectTool('save-state');
                        props.close();
                      },
                          tabindex: "0"
                        }, [
                          _createVNode(_component_font_awesome_icon, { icon: "save" }),
                          _createTextVNode(" Create link to current view")
                        ], 8, _hoisted_47)
                      ])
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, {
                      class: "tooltip-target tooltip-icon",
                      icon: "sliders-h",
                      size: "lg",
                      tabindex: "0"
                    })
                  ]),
                  _: 1
                })
              ], 512), [
                [_vShow, _ctx.showToolMenu]
              ]),
              _withDirectives(_createElementVNode("li", null, [
                _createVNode(_component_font_awesome_icon, {
                  icon: "search-plus",
                  size: "lg",
                  class: "tooltip-icon",
                  onKeyup: _cache[6] || (_cache[6] = _withKeys(($event: any) => (_ctx.doZoom(true)), ["enter"])),
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.doZoom(true))),
                  tabindex: "0"
                })
              ], 512), [
                [_vShow, !_ctx.wwtIsTourPlaying]
              ]),
              _withDirectives(_createElementVNode("li", null, [
                _createVNode(_component_font_awesome_icon, {
                  icon: "search-minus",
                  size: "lg",
                  class: "tooltip-icon",
                  onKeyup: _cache[8] || (_cache[8] = _withKeys(($event: any) => (_ctx.doZoom(false)), ["enter"])),
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.doZoom(false))),
                  tabindex: "0"
                })
              ], 512), [
                [_vShow, !_ctx.wwtIsTourPlaying]
              ]),
              _withDirectives(_createElementVNode("li", null, [
                _createVNode(_component_font_awesome_icon, {
                  icon: _ctx.fullscreenModeActive ? 'compress' : 'expand',
                  size: "lg",
                  class: "nudgeright1 tooltip-icon",
                  onKeyup: _cache[10] || (_cache[10] = _withKeys(($event: any) => (_ctx.toggleFullscreen()), ["enter"])),
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.toggleFullscreen())),
                  tabindex: "0"
                }, null, 8, ["icon"])
              ], 512), [
                [_vShow, _ctx.fullscreenAvailable]
              ])
            ], 32))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_notifications, {
      group: "load-collection",
      position: "top right"
    }),
    _createVNode(_component_notifications, {
      group: "copy-url",
      position: "top right"
    }),
    (!_ctx.hideAllChrome)
      ? _withDirectives((_openBlock(), _createElementBlock("div", {
          key: 0,
          id: "webgl2-popup",
          onKeydown: _cache[13] || (_cache[13] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createTextVNode(" To get the full WWT experience, consider using the latest version of Chrome, Firefox or Edge. In case you would like to use Safari, we recommend that you "),
          _hoisted_48,
          _createTextVNode(". ")
        ], 544)), [
          [_vShow, _ctx.wwtShowWebGl2Warning]
        ])
      : _createCommentVNode("", true)
  ]))
}